import { ZONA_HORARIA_DEFAULT } from '../constants/zona-horaria.constants';

const FORMATOS_INTL: Record<string, Intl.DateTimeFormatOptions> = {
  'HH:mm': { hour: '2-digit', minute: '2-digit', hour12: false },
  'dd/MM/yyyy': { day: '2-digit', month: '2-digit', year: 'numeric' },
  'dd/MM/yyyy HH:mm': {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  },
  'dd/MM/yyyy - HH:mm': {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  },
  'MMMM': { month: 'long' },
  'EEEE d MMMM': { weekday: 'long', day: 'numeric', month: 'long' },
  'dd/MM/yyyy HH:mm:ss': {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  },
  'HH:mm:ss': { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false },
};

function resolverTz(tz?: string): string {
  const t = tz?.trim();
  return t || ZONA_HORARIA_DEFAULT;
}

function parseInstant(value: Date | string): Date | null {
  if (value == null || value === '') return null;
  const d = typeof value === 'string' ? new Date(value) : value;
  return Number.isNaN(d.getTime()) ? null : d;
}

/** YYYY-MM-DD del instante actual en la zona de la empresa. */
export function hoyCalendarioEnEmpresa(tz?: string): string {
  const z = resolverTz(tz);
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: z,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/** Primer día del mes calendario actual en la zona de la empresa (YYYY-MM-DD). */
export function inicioMesCalendarioEnEmpresa(tz?: string): string {
  const hoy = hoyCalendarioEnEmpresa(tz);
  return `${hoy.slice(0, 7)}-01`;
}

/** Date local para datepickers a partir de YYYY-MM-DD (día de negocio). */
export function dateDesdeCalendarioEmpresa(yyyyMmDd: string): Date {
  const [y, m, d] = yyyyMmDd.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function formatInstantEnEmpresa(
  value: Date | string | null | undefined,
  tz: string | undefined,
  formato: string,
): string {
  const d = parseInstant(value as Date | string);
  if (!d) return '—';

  const z = resolverTz(tz);

  if (formato === 'DD-MM-YYYY HH:mm:ss') {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('es-CL', {
        timeZone: z,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })
        .formatToParts(d)
        .map((p) => [p.type, p.value]),
    );
    return `${parts['day']}-${parts['month']}-${parts['year']} ${parts['hour']}:${parts['minute']}:${parts['second']}`;
  }

  if (formato === 'DD-MM-YYYY') {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('es-CL', {
        timeZone: z,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
        .formatToParts(d)
        .map((p) => [p.type, p.value]),
    );
    return `${parts['day']}-${parts['month']}-${parts['year']}`;
  }

  const opts = FORMATOS_INTL[formato];
  if (!opts) {
    return new Intl.DateTimeFormat('es-CL', { timeZone: z }).format(d);
  }

  if (formato === 'dd/MM/yyyy - HH:mm') {
    const fecha = new Intl.DateTimeFormat('es-CL', {
      timeZone: z,
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(d);
    const hora = new Intl.DateTimeFormat('es-CL', {
      timeZone: z,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(d);
    return `${fecha} - ${hora}`;
  }

  return new Intl.DateTimeFormat('es-CL', { ...opts, timeZone: z }).format(d);
}
